import standardAPI from '@/api/standard_items';

const state = {
  notifications_status: '',
  notifications_MetaData: {},
  notifications_page: 1,
  notifications_perPage: 10,
};

const responseUrl = '/template-mails';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },

  fetch_notifications ({ commit }, getOptions) {
    commit('NOTIFICATIONS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };

    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('NOTIFICATIONS_SUCCESS', response);
            commit('NOTIFICATIONS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('NOTIFICATIONS_READY');
            reject(response);
          } else {
            commit('NOTIFICATIONS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },

  edit_notification ({ commit, dispatch }, itemData) {
    commit('NOTIFICATIONS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/save',
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'saved') {
          resolve(response);
        } else {
          commit('NOTIFICATIONS_READY');
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.notifications_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.notifications_perPage = max;
  },
  NOTIFICATIONS_READY: (state) => {
    state.notifications_status = 'ready';
  },
  NOTIFICATIONS_REQUEST: (state) => {
    state.notifications_status = 'loading';
  },
  NOTIFICATIONS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.notifications_MetaData.meta = response.meta;
      state.notifications_MetaData.links = response.links;
    }
    state.notifications_status = 'success';
  },
  NOTIFICATIONS_ERROR: (state) => {
    state.notifications_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
